function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.9969 44.1V76H58.3969V44.1H46.7969V41.7H72.5969V44.1H60.9969Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.7908 67.75V68.4C50.7908 70.6667 51.4242 72.35 52.6908 73.45C53.9908 74.55 55.6742 75.1 57.7408 75.1C59.8075 75.1 61.4742 74.55 62.7408 73.45C64.0408 72.3167 64.6908 70.6333 64.6908 68.4V42.7H67.3908V68.7C67.3908 71.5 66.4742 73.6667 64.6408 75.2C62.8408 76.7333 60.5408 77.5 57.7408 77.5C54.9408 77.5 52.6575 76.7333 50.8908 75.2C49.1575 73.6667 48.2908 71.5 48.2908 68.7V67.75H50.7908Z",
  fill: "white"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 119,
    viewBox: "0 0 120 119",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.6d67b5dd.svg";
export { ForwardRef as ReactComponent };